import React, { useState, useRef } from 'react';
import {
    UserProfileContainer,
    DropDownButton,
    UserNameContainer,
    ProfileInfoContainer,
    ProfilePopover,
    UserInfo,
    SalesContainer,
    MyProfileContainer,
    LogOutContainer,
    LogOutIconContainer,
    LogOutIconImage,
    LogoutText,
    EmployeeRoleContainer,
    ExtraContainer,
} from './UserProfile.styled';
import Logout from 'src/assets/images/Menu/logout.svg';
import DownArrow from '../../../assets/images/DownArrow.svg';
import Avatar from '../avatar/Avatar';
import { shallowEqual, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import LogoutPopUp from './LogoutPopUp';
import LogoutActions from 'src/common/components/logoutActions';
import { useTranslation } from 'react-i18next';
import ProxyUser from 'src/pages/more/pages/proxies/proxyBanner/userProxyPanel.jsx';
import ProxyUserList from 'src/pages/more/pages/proxies/proxyBanner/userProxyList';
import {
    checkImpersonationActive,
    checkProxyActive,
    forbiddenErrorCheck,
    logErrorToConsole,
} from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const UserProfile = (props) => {
    const { t } = useTranslation();
    const {
        givenName = 'DFirstName',
        surname = 'DLastName',
        userPrincipalName = 'DUserName',
    } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [logoutPopUp, setlogoutPopUp] = useState(false);
    const [logoutRquested, setLogoutRquested] = useState(false);
    // const [isForbidden, setIsForbidden] = useState(false);

    const ProfileEl = useRef(null);
    const PopoverId = anchorEl ? 'simple-popover' : undefined;
    const open = Boolean(anchorEl);
    // eslint-disable-next-line no-unused-vars
    const openPopOver = (event) => {
        setAnchorEl(ProfileEl.current);
    };
    const userDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );
    // const isForbidden = useSelector(
    //     (state) => state.loginReducer.isForbidden
    // );

    const { proxies } = useSelector(
        (state) => state.loginReducer.moreVisibility
    );

    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );
    const isDestructiveEnabled = useSelector(
        (state) => state.loginReducer.isDestructiveEnabled
    );
    const isDestructive =
        isDestructiveEnabled ||
        (bannerInfo &&
            !checkProxyActive() &&
            !checkImpersonationActive() &&
            bannerInfo.filter(
                (item) => item.messageType === 'userDestructiveMessage'
            ).length > 0);

    const { officeLocation, salesStructure } = userDetails;

    const logout = () => {
        setLogoutRquested(true);
    };

    const onLogout = () => {
        setAnchorEl(null);
        setlogoutPopUp(true);
    };

    const onClose = () => {
        setlogoutPopUp(false);
    };
    const initiateProxyStatus = useSelector(
        (state) => state.InitiateProxyReducer.statusCode
    );
    // useEffectWithErrorLogging(()=>{
    //     setIsForbidden(true);
    // },[]);
    // useEffectWithErrorLogging(()=>{
    //     forbiddenErrorCheck(instance, dispatch, logoutAPI) ? setIsForbidden(false) : setIsForbidden(true);
    // }, [isForbidden]);
    useEffectWithErrorLogging(() => {
        if (initiateProxyStatus === '200') {
            setAnchorEl(null);
        }
    }, [initiateProxyStatus]);
    return (
        <>
            <UserProfileContainer
                id="user-profile-header"
                // onClick={(e) => {
                //     openPopOver(e);
                //     console.log('click');
                // }}
                isSideNavBar={props.isSideNavBar}
            >
                <LogoutActions
                    logoutRquested={logoutRquested}
                    setlogoutPopUp={setlogoutPopUp}
                />
                <DropDownButton isSideNavBar={props.isSideNavBar}>
                    <img
                        ref={ProfileEl}
                        src={DownArrow}
                        alt="dropdown"
                        onClick={(e) => {
                            openPopOver(e);
                        }}
                        width="auto"
                        height="auto"
                    />
                </DropDownButton>
                <Avatar intials={givenName[0] + surname[0]} />
                <UserNameContainer id="userProfile-name-pii" isSideNavBar={props.isSideNavBar}>
                    {givenName} {surname}
                    <span className="mail">{userPrincipalName}</span>
                </UserNameContainer>
                <ProfilePopover
                    id={PopoverId}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={() => {
                        try {
                            setAnchorEl(null);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    disableScrollLock
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    hasBanner={props.hasBanner}
                >
                    <ProfileInfoContainer>
                        <UserInfo>
                            {!isDestructive && !forbiddenErrorCheck() && (
                                <SalesContainer wordBreak={'break-word'}>
                                    {salesStructure?.slice(0, 1).map((item) => {
                                        return (
                                            <span key={item.salesForceId}>
                                                {item.district}
                                                <br />
                                                <span>
                                                    {item.territory}
                                                    {salesStructure?.length >
                                                        1 && (
                                                        <ExtraContainer
                                                            onClick={() => {
                                                                try {
                                                                    props.openProfileDialog();
                                                                    setAnchorEl(
                                                                        null
                                                                    );
                                                                } catch (error) {
                                                                    logErrorToConsole(error);
                                                                }
                                                            }}
                                                        >
                                                            +{' '}
                                                            {salesStructure.length -
                                                                1}{' '}
                                                            {t(
                                                                'common.moreLabel'
                                                            )}
                                                        </ExtraContainer>
                                                    )}
                                                </span>
                                            </span>
                                        );
                                    })}
                                </SalesContainer>
                            )}
                            {!isDestructive && !forbiddenErrorCheck() && (
                                <EmployeeRoleContainer id="userProfile-location-pii">
                                    {/* {employeeRole}
                                    <br /> */}
                                    {officeLocation}
                                </EmployeeRoleContainer>
                            )}
                            {!isDestructive && !forbiddenErrorCheck() && (
                                <MyProfileContainer
                                    onClick={() => {
                                        try {
                                            props.openProfileDialog();
                                            setAnchorEl(null);
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                >
                                    {t('common.myProfileLabel')}
                                </MyProfileContainer>
                            )}
                            {checkProxyActive() && <ProxyUser />}
                            {proxies &&
                                !isDestructive &&
                                !forbiddenErrorCheck() && (
                                    <ProxyUserList
                                        onHide={() => {
                                            try {
                                                props.closeSideNavBar();
                                            } catch (error) {
                                                logErrorToConsole(error);
                                            }
                                        }}
                                    />
                                )}
                            <LogOutContainer
                                onClick={() => {
                                    try {
                                        onLogout();
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                            >
                                <NavLink to="/"></NavLink>
                                <LogOutIconContainer>
                                    <LogOutIconImage
                                        defaultImg={Logout}
                                        name="logout"
                                    />
                                </LogOutIconContainer>
                                <LogoutText>
                                    {t('common.logoutButton')}
                                </LogoutText>
                            </LogOutContainer>
                        </UserInfo>
                    </ProfileInfoContainer>
                </ProfilePopover>
            </UserProfileContainer>
            {logoutPopUp && (
                <LogoutPopUp
                    logout={() => {
                        try {
                            logout();
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    onClose={() => {
                        try {
                            onClose();
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
            )}
        </>
    );
};

export default UserProfile;
